import React from 'react';
import axios from 'axios';
import url from 'url';
import { config } from '../../constants/Constants';
import $ from 'jquery';
import SprachtestPostMsg from "./SprachtestPostMsg";
import SprachtestPostMsgTestPage from "./SprachtestPostMsgTestPage";


class TestStartPage extends React.Component{

    constructor(){
        super();
        this.state = {
            htmlTestPage: '',
        }
    }
    componentDidMount() {
        this.getStartTestJson();
    }
    getStartTestJson(){
        let homeurl = config.url.API_URL;
        let test, urlpath;
        let jsonUrl;

        if(process.env.NODE_ENV === "development"){
            //urlpath = "https://sprachtest.local.de/einstufungstest-deutsch?pid=57&gid=79&auth_id=1";
            //urlpath = url.parse("https://sprachtest.local.de/einstufungstest-englisch");
            urlpath = window.location.href+'einstufungstest-italienisch';
            jsonUrl = 'https://sprachtest.local.de/node/135?_format=json';
        }else{
            urlpath = window.location.href;
            jsonUrl = '/node/135?_format=json';
        }

    /*    console.log(jsonUrl);
        console.log(urlpath);*/


        let urlstr = url.parse(urlpath);
        if(urlstr.path && urlstr.pathname){
            if(urlstr.path === urlstr.pathname){
                test = urlstr.path.split('-')[1];
                if(test=='business'){
                    test = test+'-'+urlstr.path.split('-')[2];
                }
                if(test=='franzoesisch'){
                    test = 'französisch';
                }
            }else{
                test = urlstr.pathname.split('-')[1];
                if(test=='business'){
                    test = test+'-'+urlstr.path.split('-')[2].split('?')[0];
                }
                if(test=='franzoesisch'){
                    test = 'französisch';
                }
            }
        }
        test = '<h1 class="langTest">'+test.replace('-',' ')+'&nbsp;'+'</h1>';

        axios.get(jsonUrl).then(data => {
            this.setState({htmlTestPage:test+data.data.body[0].processed})
        }) .catch(err => {
            console.log('Error happened during fetching!', err);
        });
    }

  /*  handleSelect(){
        console.log($(this).closest("ul").children());
        $(this).closest("ul").children('li:not(.init)').toggle();
    }*/
    render(){
     /*   console.log('in test start page')*/
        return(
            <div>
               {/* <SprachtestPostMsgTestPage/>*/}
               {/* <SprachtestPostMsg/>*/}
                <div className="instructions" dangerouslySetInnerHTML={{__html:this.state.htmlTestPage}}>

                </div>

            </div>
        )
    }
}

export default TestStartPage;
